import { FC } from 'react';
import { Box, Typography } from '@mui/material';

interface NamedEntitiesProps {
  entitiesString: string | string[] | null;
}

const NamedEntities: FC<NamedEntitiesProps> = ({ entitiesString }) => {
  // Convert array to string if needed
  const stringValue = Array.isArray(entitiesString) ? entitiesString.join(', ') : entitiesString;

  if (!stringValue || stringValue.trim() === '') {
    return null;
  }

  const trimmed = stringValue.trim();
  if (trimmed.toLowerCase() === 'none') {
    return (
      <Typography
        component="span"
        variant="body2"
        color="textPrimary"
        sx={{ fontSize: '14px', lineHeight: 1.43, letterSpacing: '0.4px' }}
      >
        {trimmed}
      </Typography>
    );
  }
  const entities = trimmed
    .split(',')
    .map((entity) => entity.trim())
    .filter((entity) => entity.length > 0 && entity.toLowerCase() !== 'none');

  if (entities.length === 0) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        columnGap: 0.5,
        rowGap: 0.25,
        whiteSpace: 'normal',
      }}
    >
      {entities.map((entity, index) => (
        <Typography
          key={`${entity}-${index}`}
          component="span"
          variant="body2"
          color="textPrimary"
          sx={{
            fontSize: '14px',
            lineHeight: 1.43,
            letterSpacing: '0.4px',
            overflowWrap: 'break-word',
          }}
        >
          {entity}
          {index < entities.length - 1 ? ', ' : ''}
        </Typography>
      ))}
    </Box>
  );
};

export default NamedEntities;
